import Symbol from "./Symbol";
import { INSPECTOR_ENGINE_CONTROL_CENTER } from "../../../constants/inspectorConstants";

// Centro de Control de Motores
class EngineControlCenter extends Symbol {
    constructor({ alias, svgSrc, label, rotable, handles, name}) {
        super("EngineControlCenter", { alias, svgSrc, label, rotable, handles, name });

        this.attributes = {
            ...this.attributes,
            brand: { isVisible: false, value: null, label: "Marca" },
            model: { isVisible: false, value: null, label: "Modelo" },
            numberSections: { isVisible: false, value: null, label: "Número de Secciones" },
            ratedVoltage: { isVisible: false, value: null, label: "Voltaje nominal" },
            ratedCurrent: { isVisible: false, value: null, label: "Corriente Nominal" },
            shortcircuitCapacity: { isVisible: false, value: null, label: "Capacidad de Cortocircuito" },
            numberCompartment: { isVisible: false, value: null, label: "Número de Compartimientos" },
            electrodeConfiguration: { isVisible: false, value: null, label: "Configuración electrodos" },
            height: { isVisible: false, value: null, label: "Alto" },
            length: { isVisible: false, value: null, label: "Ancho" },
            width: { isVisible: false, value: null, label: "Profundo" },
        };                
    }

    getInspector() {
        return INSPECTOR_ENGINE_CONTROL_CENTER;
    }
}

export default EngineControlCenter;
